import { render, staticRenderFns } from "./SuperEffective.vue?vue&type=template&id=6e8ac496&scoped=true&"
import script from "./SuperEffective.vue?vue&type=script&lang=ts&"
export * from "./SuperEffective.vue?vue&type=script&lang=ts&"
import style0 from "./SuperEffective.vue?vue&type=style&index=0&id=6e8ac496&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e8ac496",
  null
  
)

export default component.exports